import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";

const initialState = {
  isMainCLoading: false,
  isSubCLoading: false,
  mainData: [],
  subData: [],
  error: null,
  specificAPIParams: null
};

const GetCategorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    userMainCategoryforAPI(state, action){
      return{...state, specificAPIParams : action?.payload}
    },
    userGetMainCategoryRequest(state, action) {
      return { ...state, isMainCLoading: true };
    },
    userGetMainCategorySuccess(state, action) {
      return { ...state, mainData: action.payload, isMainCLoading: false };
    },
    userGetMainCategoryFailure(state, action) {
      Swal.fire({
        position: "center",
        icon: "error",
        text: action?.payload?.message,
      });
      return { ...state, isMainCLoading: false };
    },
    userGetSubCategoryRequest(state, action) {
      return { ...state, isSubCLoading: true };
    },
    userGetSubCategorySuccess(state, action) {
      return { ...state, subData: action.payload, isSubCLoading: false };
    },
    userGetSubCategoryFailure(state, action) {
      Swal.fire({
        position: "center",
        icon: "error",
        text: action?.payload?.message,
      });
      return { ...state, isSubCLoading: false };
    },
  },
});

export const {
  userGetMainCategoryFailure,
  userGetMainCategoryRequest,
  userGetMainCategorySuccess,
  userGetSubCategoryFailure,
  userGetSubCategoryRequest,
  userGetSubCategorySuccess,
  userMainCategoryforAPI
} = GetCategorySlice.actions;
export default GetCategorySlice.reducer;
